import React, { useEffect, useState } from "react";
import { Question } from "../types";
import { deleteSurveyQuestion } from "../Firebase/utils";
import { deleteQuestion } from "../store/features/CreateSurveySlice";
import { useAppDispatch, useAppSelector } from "../store/store";
import YesOrNoForm from "./YesNoForm";
import { updateQuestionResponse } from "../store/features/CompleteSurveySlice";
import QuestionResponseContainer from "./QuestionResponseContainer";

interface YesNoOptionsPreviewDisplayProps {
    question: Question;
    questionText: string;
    options: string[];
}

export default (props: YesNoOptionsPreviewDisplayProps) => {

    const { question, questionText, options } = props;
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);
    const [ selection, setSelection ] = useState<string>('');

    useEffect(() => {
        dispatch(updateQuestionResponse({questionId:question.id, response:selection}))
    }, [selection]);

    return (
        <QuestionResponseContainer question={question}>
            <div className="flex gap-4">
                <button onClick={() => setSelection('Yes')} className={`w-1/2 bg-[#${selection === 'Yes' ? '3da8e2' : '1b1a1a'}] text-white p-2 rounded-md border-[#8dd2f6] border shadow-black shadow-lg font-BardotBold tracking-widest`}>{options[0]}</button>
                <button onClick={() => setSelection('No')} className={`w-1/2 bg-[#${selection === 'No' ? '3da8e2' : '1b1a1a'}] text-white p-2 rounded-md border-[#8dd2f6] border shadow-black shadow-lg font-BardotBold tracking-widest`}>{options[1]}</button>
            </div>
        </QuestionResponseContainer>
    )
}